import { CONTACT } from '../data/contact';

export const NAVIGATION_ITEMS = [
  { id: 'home', name: 'Home', href: '/', isHash: false },
  { id: 'partners', name: 'Partners', href: '/partners', isHash: false },
  { id: 'portfolio', name: 'Work', href: '/portfolio', isHash: false },
  { id: 'blogs', name: 'Notes', href: '/blogs', isHash: false },
  { id: 'connect', name: 'Connect', href: '/connect', isHash: false },
];

export { PORTFOLIO_CATEGORIES } from '../data/portfolio';

export const ANIMATION_CONFIG = {
  duration: 0.45,
  ease: [0.22, 1, 0.36, 1],
  stagger: 0.06,
};

export const SEO_DEFAULTS = {
  title: 'LogitsLab — AI that ships in production',
  description:
    'LogitsLab builds production AI for vision, language, and multimodal systems. Official tech partner of Byondbites, Valken, and SelfAgentic. Makers of MindKshetra. AI developed for CamerEye, ParkView, Looq, RTSH, and Nuvve — delivered through Toptal.',
  keywords:
    'LogitsLab, Computer Vision, LLM, MindKshetra, Byondbites, Valken, SelfAgentic, CamerEye, ParkView, Looq, RTSH, Nuvve, Toptal, AI engineering',
  author: 'LogitsLab',
  siteName: CONTACT.siteName,
  url: CONTACT.siteUrl,
  email: CONTACT.email,
  phone: CONTACT.phone,
};
